import { colors } from "@areahub/theme";
import { FeedbackForm } from "./form";
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef } from "react";

export const FeedbackTrigger = () => {
  const initialFocusRef = useRef(null);
  const { onOpen, onClose, isOpen } = useDisclosure();
  return (
    <Popover
      id="feedback-button"
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      initialFocusRef={initialFocusRef as React.RefObject<any>}
      placement="bottom"
      closeOnBlur
      closeOnEsc
      preventOverflow
      computePositionOnMount
    >
      <PopoverTrigger>
        <Button
          variant="outline"
          h="7"
          aria-label="Provide Your Feedback"
          className="feedback-trigger"
          bgColor={"white"}
          mt={5}
        >
          Send us Feedback
        </Button>
      </PopoverTrigger>
      <PopoverContent
        boxShadow="xl"
        p="3"
        _focus={{ outline: "none" }}
        zIndex={5}
        className="feedback-form"
        w="fit-content"
      >
        <FeedbackForm forwardedRef={initialFocusRef} {...{ onClose }} />
      </PopoverContent>
    </Popover>
  );
};
